import React from 'react'
import Service from './Service';
import a1 from '../../Assets/images/202.jpeg'
import a2 from '../../Assets/images/204.jpeg'
import a3 from '../../Assets/images/205.jpeg'
import a4 from '../../Assets/images/201.jpeg'

function Services() {
  const services = [{
    _id: 1,
    name: 'Who we are',
    img: a1,
    description: "LifeLong365 offers a wide variety of information from schools to corporate",
    myText:"Get to know",
    path:"/backLink"
    
  },
  {
    _id: 2,
    name: 'In certification',
    img: a3,
    description: "Certificate exams provide a way for individuals to validate their knowledge and skills",
    myText:"Certificate Info",
    path:"/certificate"
    
  },
  {
    _id: 3,
    name: 'In career',
    img: a2,
    description: "Job preparation, Skill up, Living hacks, and other necessary info are found in this app",
    myText:"Career Info",
    path:"/career"
   
  },
  ]
  return (
    <div class="mt-20">
      <div className='grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 pt-6 gap-10'>

        {
          services.map(service => <Service
            key={service._id}
            service={service}></Service>)
        }

      </div>


    </div>
  )
}

export default Services;